import {NewsDataTypes} from 'models';
// import COVID_19_IMAGE from 'assets/news/covid_19_safety.png';
// import GREAT_BOOKS_IMAGE from 'assets/news/great_books_to_read.png';
// import HOW_TO_START_IMAGE from 'assets/news/how_to_start_a_business.png';
// import COVID_HEADER_IMAGE from 'assets/news/news_covid_header_image.png';
// import START_BUSINESS_HEADER_IMAGE from 'assets/news/start_a_business_header_image.png';
// import GREAT_BOOKS_HEADER_IMAGE from 'assets/news/great_books_header.png';
// import COVID_BUSINESS_IMAGE from 'assets/news/covid_vaccination.png';
// import GIRL_IMAGE from 'assets/news/girl_image.png';
// import MALE_IMAGE from 'assets/news/male_image.png';
//
// const body = "Aliquet tempus magna ullamcorper ante praesent eget bibendum. Suspendisse risus nisi, vitae sit. Sed adipiscing id tempor interdum ipsum, enim. Tempor libero sit ipsum vitae nisl euismod tristique. Faucibus magna in eget donec at. Proin id quam pellentesque pellentesque suspendisse cum bibendum tortor, lectus. Duis risus, sed vestibulum arcu vulputate. Tincidunt nec orci lacus, aenean fringilla. Elit id cursus nam rhoncus, arcu, adipiscing amet id et.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquet tempus magna ullamcorper ante praesent eget bibendum. Suspendisse risus nisi, vitae sit. Sed adipiscing id tempor interdum ipsum, enim. Tempor libero sit ipsum vitae nisl euismod tristique. Faucibus magna in eget donec at. Proin id quam pellentesque pellentesque suspendisse cum bibendum tortor, lectus.";
//
export const newsData: NewsDataTypes[] = []
//     {
//         id: "covid_19_safety_guide_for_businesses",
//         heading: "Covid 19 Safety Guide for Businesses",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis.",
//         date: "January 2, 2022",
//         link: "news",
//         image: COVID_19_IMAGE,
//         isPopular: true,
//         headerImage: COVID_HEADER_IMAGE,
//         author: "Kimberly Clarke",
//         // sections: [
//         //     {
//         //         heading: "",
//         //         body: body,
//         //     },
//         //     {
//         //         heading: "Actively encourage sick employees to stay home",
//         //         body: body
//         //     },
//         //     {
//         //         heading: "Consider conducting daily in-person or virtual health checks",
//         //         body: body
//         //     },
//         //     {
//         //         heading: "Social Distancing:",
//         //         body: body
//         //     },
//         //     {
//         //         heading: "Barrier/Partitional Controls",
//         //         body: body
//         //     },
//         //     {
//         //         heading: "Encourage work from home when possible. ",
//         //         body: body
//         //     },
//         // ]
//     },
//     {
//         id: "how_to_start_a_business_in_jamaica",
//         heading: "How to Start a Business in Jamaica",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis.",
//         date: "January 2, 2022",
//         link: "news",
//         image: HOW_TO_START_IMAGE,
//         isPopular: true,
//         headerImage: START_BUSINESS_HEADER_IMAGE,
//         author: "Kimberly Clarke",
//         sections: [
//             {
//                 heading: "",
//                 body: body,
//             },
//             {
//                 heading: "Conduct market research",
//                 body: body
//             },
//             {
//                 heading: "Write your business plan",
//                 body: body
//             },
//             {
//                 heading: "Create Business Name and Choose Platform",
//                 body: body
//             },
//             {
//                 heading: "Register Your Business",
//                 body: body
//             },
//             {
//                 heading: "Create Business Tax Administration Account",
//                 body: body
//             },
//             {
//                 heading: "Open Business Bank Account",
//                 body: body
//             },
//             {
//                 heading: "Start Offering your Services or Product",
//                 body: body
//             },
//
//         ]
//
//
//     },
//     {
//         id: "great_books_to_read_in_2022",
//         heading: "Great Books You Should Read in 2022",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis.",
//         date: "January 2, 2022",
//         link: "news",
//         image: GREAT_BOOKS_IMAGE,
//         isPopular: true,
//         headerImage: GREAT_BOOKS_HEADER_IMAGE,
//         author: "Kimberly Clarke",
//         sections: [
//             {
//                 heading: "",
//                 body: body,
//             },
//             {
//                 heading: "Book Title Here",
//                 body: body
//             },
//             {
//                 heading: "Book Title Here",
//                 body: body
//             },
//             {
//                 heading: "Book Title Here",
//                 body: body
//             },
//             {
//                 heading: "Book Title Here",
//                 body: body
//             },
//             {
//                 heading: "Book Title Here",
//                 body: body
//             },
//         ]
//     },
//     {
//         id: "our_list_of_business_ideas",
//         heading: "Our List of Business Ideas",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis.",
//         date: "January 2, 2022",
//         link: "news",
//         image: GIRL_IMAGE,
//         isPopular: false,
//         headerImage: COVID_HEADER_IMAGE,
//         author: "Kimberly Clarke",
//         sections: [
//             {
//                 heading: "",
//                 body: body,
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//         ]
//     },
//     {
//         id: "how_does_the_sbaj_membership_program_work",
//         heading: "How Does the SBAJ Membership Program Work",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis.",
//         date: "January 2, 2022",
//         link: "news",
//         image: MALE_IMAGE,
//         isPopular: false,
//         headerImage: COVID_HEADER_IMAGE,
//         author: "Kimberly Clarke",
//         sections: [
//             {
//                 heading: "",
//                 body: body,
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//             {
//                 heading: "Heading Here",
//                 body: body
//             },
//         ]
//     },
//     {
//         id: "covid_19_and_businesses",
//         heading: "COVID-19 and Businesses",
//         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis.",
//         date: "March 12, 2021",
//         link: "news",
//         image: COVID_BUSINESS_IMAGE,
//         isPopular: false,
//         headerImage: COVID_HEADER_IMAGE,
//         author: "Kimberly Clarke",
//         sections: [
//             {
//                 heading: "",
//                 body: body,
//             },
//             {
//                 heading: "Actively encourage sick employees to stay home",
//                 body: body
//             },
//             {
//                 heading: "Consider conducting daily in-person or virtual health checks",
//                 body: body
//             },
//             {
//                 heading: "Social Distancing:",
//                 body: body
//             },
//             {
//                 heading: "Barrier/Partitional Controls",
//                 body: body
//             },
//             {
//                 heading: "Encourage work from home when possible. ",
//                 body: body
//             },
//         ]
//     },
// ]